import { ONBOARDING_STATUS_STORE_INJECTION_KEY } from "@/store/keys";
import { inject } from "vue";
import { AppPages } from "@/router/pages";

export async function loadOnboardingStatusGuard () {
  const onboardingStatusStore = inject(ONBOARDING_STATUS_STORE_INJECTION_KEY);
  if (onboardingStatusStore) {
    await onboardingStatusStore.loadOnboardingStatus();
  }
  return true;
}

export async function redirectToProductGuard () {
  const onboardingStore = inject(ONBOARDING_STATUS_STORE_INJECTION_KEY)!;
  const nextPage = onboardingStore.getNextPage() || AppPages.Onboarding;

  if (nextPage !== AppPages.RedirectToProduct) {
    return {
      name: nextPage,
    };
  }
  const productUrl =onboardingStore.getProductUrl();
  if (!productUrl) {
    return false;
  }

  await new Promise(resolve => setTimeout(resolve, 0.8e3));

  window.location.href = productUrl;
}
